import { __, append, contains, curry, descend, ifElse, includes, propOr, without } from 'ramda'
import React, { useEffect, useState } from 'react'
import { Gap } from '../../../shared/ui/gap'
import { setUrlVars } from '../../../shared/utils/url'
import ConfiguratorButton from '../product-detail/configurator-button'
import FilterPanel from './filter-panel'
import ProductCard from './product-card'
import { List, Root } from './styled'
import AreaFilterPanel from './area-filter-panel'
import { getCountryCookie } from '../../../shared/utils/cookies'
import { isNorthAmericaRegion } from '../../../shared/context/site-area'

const toggleListItem = curry((value, list) => ifElse(
  contains(value),
  without([value]),
  append(value),
)(list));


const ProductList = props => {
  const [siteArea, setSiteArea] = useState(props.filterSiteArea)
  const [filterState, setFilters] = useState(props.initialFiltersFromUrl)
  const { products, urlPath, showSiteAreaFilters, hideConfigurator } = props

  const filterProduct = product => {
    const { categories = [], siteAreas = [] } = product
    const currentCountry = getCountryCookie()
    let filterSiteArea = siteArea
    if (filterSiteArea && isNorthAmericaRegion(currentCountry)) {
      filterSiteArea = `${siteArea}-na`
    }
  
    const productHasCategory = filterState.length === 0 || categories.some(includes(__, filterState))
    const productIsFromArea = !filterSiteArea || siteAreas.includes(filterSiteArea)

    return productHasCategory && productIsFromArea
  }

  const toggleFilter = filter => {
    if (filterState.indexOf(filter) !== -1) {
      setFilters(toggleListItem(filter))
    } else {
      setFilters([filter])
    }
  }

  useEffect(() => {
    setUrlVars({
      filters: filterState.length !== 0
        ? filterState.join(',')
        : null
    })
  }, [filterState])

  const currentSiteArea = siteArea || props.siteArea
  return (
    <Root>
      <Gap />
      {showSiteAreaFilters && <AreaFilterPanel siteArea={siteArea} setSiteArea={setSiteArea} setFilters={setFilters} />}
      <FilterPanel siteArea={currentSiteArea} filterState={filterState} toggleFilter={toggleFilter} />
      {!hideConfigurator && <ConfiguratorButton siteArea={currentSiteArea} />}
      <Gap />
      <List>
        {products
          .filter(filterProduct)
          .sort(descend(propOr(0, 'relevancy')))
          .map(product => <li key={product.id}><ProductCard urlPath={urlPath} siteArea={props.siteArea} {...product} /></li>)
        }
      </List>
    </Root>
  )
}

export default ProductList
